import Vue from "vue";
import Vuex from "vuex";

// Packages
import config from "/config";
import packages from "../modules";

// Main
import Api from "./api";
import utils from "./utils";

// JOSN Files
import en from '/api/lang/en.json'
import de from '/api/lang/de.json'
import ar from '/api/lang/ar.json'

// Setup Language
let language = en
switch (localStorage.language) {
    case 'de':
        language = de
        break;
    case 'ar':
        language = ar
        break;
}

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        utils: new utils(),
        config: config,
        language: language,
        updatingGalleryObject: undefined,
        updatingPostsObject: undefined,
        api: Api,
        modules: {
            api: packages.api,
            account: {
                user: undefined,
                token: undefined
            },
        },
    }
});